import theme from '@/helpers/theme';
import { Box, Stack } from '@mui/material';
import { RiCopperCoinLine } from 'react-icons/ri';

import type { WalletCoin } from '@/types';
import type { DispenseAssetView } from '@/types/generated/athena';

type Props = {
  hideChain?: boolean;
  coin?: WalletCoin;
  asset?: DispenseAssetView;
  width?: number;
  height?: number;
};

export const CoinIcon = ({ coin, asset, width = 32, height = 32, hideChain = false }: Props) => {
  const isToken = coin?.is_token;
  const logo = coin?.logo_url ?? asset?.logo_url;
  const chainLogo = coin?.chain?.logo_url;
  return (
    <Stack
      position="relative"
      alignItems="center"
      justifyContent="center"
      width={width}
      height={height}
      bgcolor={theme.palette.action.active}
      borderRadius={9999}
    >
      <RiCopperCoinLine color="white" size={24} />
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        sx={{
          background: `url(${logo})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      />
      {!hideChain && isToken && chainLogo && (
        <Box
          position="absolute"
          height="50%"
          width="50%"
          right={-4}
          bottom={-4}
          border={2}
          borderRadius={999}
          borderColor="white"
          sx={{
            background: `url(${chainLogo})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        />
      )}
    </Stack>
  );
};
